import '@babel/polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueSwiper from 'vue-awesome-swiper'
import './assets/css/swiper-3.4.2.min.css'
import './utils/rem.js'
// import './utils/rems.js'
import scroll from 'vue-seamless-scroll'
import {
  Dialog,
  Tree,
  Image,
  Pagination,
  Message,
  MessageBox,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Axios from 'axios'
Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/api'
Vue.component(Dialog.name, Dialog)
Vue.component(MessageBox.name, MessageBox)
Vue.component(Tree.name, Tree)
Vue.component(Image.name, Image)
Vue.component(Message.name, Message)
Vue.component(Pagination.name, Pagination)
Vue.use(scroll)
Vue.use(vueSwiper)
Vue.use(router)
Vue.config.productionTip = false
new Vue({
  el: '#app',
  render: (h) => h(App),
  router,
}).$mount('#app')
